import {useAppDispatch, useAppSelector} from "../redux/stateHooks";
import {setPromotionCode} from "../redux/slices/addToCart";

export const useOnCouponCodeSelect = () => {
    const dispatch = useAppDispatch();
    const promotionCode = useAppSelector((state) => state.addToCart.value.promotionCode);
    return {
        applied: !!promotionCode,
        setPromotionCode: (promotionCode: string) => dispatch(setPromotionCode(promotionCode))
    }
}